import { useFormikContext } from "formik";

export const useIsSinglePerson = (): boolean => {
  const {
    values: { c1001, c1003, c1007, c1010, c1014, c1016, c1018, c1019, c1021, c1022 },
  } = useFormikContext();

  return !!(c1001 || c1003 || c1007 || c1010 || c1014 || c1016 || (c1018 && !c1019) || c1021 || c1022);
};
